import * as actions from "../actions";

const initialState = {
  completionReference: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_PAYMENT_REFERENCE:
      return {
        ...state,
        ...action.payload
      }
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
